import React from 'react';
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  NavLink,
  Table,
  Container,
  Row, Collapse,
  Col, FormGroup, Input, Label, FormText, Modal, Spinner, ModalBody, ModalFooter,
} from "reactstrap";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import { useHistory } from "react-router-dom";
import decodeJwt from 'jwt-decode';
import ModalImage from "react-modal-image";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";


const EditCategory = ({ data, category, places, open, setOpen }) => {
  const history = useHistory();
  const [color_code, setColor_code] = useState(data.color_code);
  const [parent_update, setParent_update] = useState(data.parent);
  const [guPlacesArr, setGUPlacesArr] = useState(data.groundfloor_upstairs);
  const [ioPlacesArr, setIOPlacesArr] = useState(data.indoor_outdoor);
  const [editPlaceRadio, setEditPlaceRadio] = useState(data.places);
  const [loading, setLoading] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [indcollapse, setIndcollapse] = useState(false);
  const [flag, setFlag] = useState(false);
  const [editsucess, setEditsucess] = useState(false);
  const [images, setImages] = useState(null)
  const [iconimage, setIconimage] = useState(null)

  const fileHandler = (e) => {
    setImages(e.target.files[0])
  }
  const fileHandlericon = (e) => {
    setIconimage(e.target.files[0])
  }

  // const ioParentChange = (e, index, pid) => {
  //   let Exist = ioPlacesArr.length && ioPlacesArr.find(item => item.location === pid);
  //   if (!Exist) {
  //     // setIOPlacesArr(prevState => [...prevState, { location: pid, sublocation: [] }]);
  //     setIOPlacesArr([{ location: pid, sublocation: [] }])
  //   }
  //   if (e.target.checked) {
  //     setIndcollapse(index)
  //   } else {
  //     setIndcollapse(false);
  //   }
  // }
  const ioParentChange = (check, index, pid) => {
    if (check) {
      setIOPlacesArr(prevState => [...prevState, { location: pid, sublocation: [] }]);
    }
    else {
      let arrAfterRemove = ioPlacesArr.filter(item => item.location !== pid)
      setIOPlacesArr(arrAfterRemove);
    }
    // if (check) {
    //   setIndcollapse(index);
    // } else {
    //   setIndcollapse(false);
    // }
  }
  const ioChildChange = (check, child, pid) => {
    if (check) {
      let Exist = ioPlacesArr.length && ioPlacesArr.find(item => item.location === pid);
      if (Exist) {
        let NewArr = ioPlacesArr.length && ioPlacesArr.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        childrenExist.push(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setIOPlacesArr(NewArr);
      }
      else {
        let childrenArr = [];
        childrenArr.push(child);
        childrenArr = [...new Set(childrenArr)];
        let info = { location: pid, sublocation: childrenArr };
        setIOPlacesArr(prevState => [...prevState, info]);
      }
    } else {
      let Exist = ioPlacesArr.length && ioPlacesArr.find(item => item.location === pid);
      if (Exist) {
        let NewArr = ioPlacesArr.length && ioPlacesArr.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        var i = childrenExist.indexOf(child);
        if (i !== -1) {
          childrenExist.splice(i, 1);
        }
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setIOPlacesArr(NewArr);
      }
    }
  }
  const groundfloor_upstairs = (check, child, pid) => {
    if (check) {
      let Exist = guPlacesArr.length && guPlacesArr.find(item => item.location === pid);
      if (Exist) {
        let NewArr = guPlacesArr.length && guPlacesArr.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        childrenExist.push(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setGUPlacesArr(NewArr);
        setFlag(!flag)
      }
      else {
        let childrenArr = [];
        childrenArr.push(child);
        childrenArr = [...new Set(childrenArr)];
        let info = { location: pid, sublocation: childrenArr };
        setGUPlacesArr(prevState => [...prevState, info]);
        setFlag(!flag)
      }
    } else {
      let Exist = guPlacesArr.length && guPlacesArr.find(item => item.location === pid);
      if (Exist) {
        let NewArr = guPlacesArr.length && guPlacesArr.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        var i = childrenExist.indexOf(child);
        if (i !== -1) {
          childrenExist.splice(i, 1);
        }
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setGUPlacesArr(NewArr);
        setFlag(!flag)
      }
    }
  }
  const onSubmit_update = (values, id) => {
    dataProvider.updateCategories('category', { ...values, parent: values.parent ? values.parent : null, id: data._id, places: editPlaceRadio, color_code: color_code, groundfloor_upstairs: editPlaceRadio === 'GroundFloor/Upstairs' ? guPlacesArr : [], indoor_outdoor: editPlaceRadio === 'Indoor/Outdoor' ? ioPlacesArr : [] })
      .then(({ data }) => {
        setLoading(false);
        setEditsucess(true)
        setTimeout(() => Pushedit(), 2000);
        setLoading(false)
        history.push("/categories")
      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });
  }
  const Pushedit = () => {
    setEditsucess(false)
    window.location.reload()
    // setOpen(false);
  }
  return (
    <>
      <Form
        onSubmit={onSubmit_update}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
            <div className="pl-lg-4">
              <Col lg="12">
                <FormGroup>
                  <Label style={{ fontSize: ' 0.8125rem' }} for="name">Category Name</Label>
                  <Field name="category" initialValue={data.category ? data.category : null} >
                    {({ input, meta }) => (
                      <div>
                        <Input
                          {...input}
                          style={{ color: 'black' }}
                          type="text"
                          placeholder="Category Name"
                        />
                      </div>
                    )}
                  </Field>
                </FormGroup>
              </Col>
              <Col lg="12">
                <FormGroup >
                  <Label style={{ fontSize: ' 0.8125rem' }}>Category</Label>
                  <Field name="parent" initialValue={parent_update}>
                    {({ input, meta, value }) => (
                      <div>
                        <Input type="select" {...input} onChange={(e) => setParent_update(e.target.value)} name="parent" style={{ color: 'black' }}>
                          <option value="" style={{ color: '#ccc' }} >Choose parent Category</option>
                          {category && category.map((item, index) => {
                            if (!item.parent) {
                              return (<option value={item.id}>{item.category}</option>)
                            }
                            else { return null; }
                          })}

                        </Input>
                      </div>
                    )}
                  </Field>
                </FormGroup>
              </Col>
              <Col lg="12">
                <FormGroup>
                  <Label style={{ fontSize: ' 0.8125rem' }} for="name">Arabic Name</Label>
                  <Field name="category_arabic" initialValue={data.category_arabic ? data.category_arabic : null}>
                    {({ input, meta }) => (
                      <div>
                        <Input
                          {...input}
                          style={{ color: 'black' }}
                          type="text"
                          placeholder="Arabic Name"
                        />
                      </div>
                    )}
                  </Field>
                </FormGroup>
              </Col>
              {data.icon_path && (
                <Col lg="6"
                  style={{ backgroundColor: 'rgb(103 120 136)', width: 100, marginLeft: 20, borderRadius: 5, padding: 18 }}>
                  <img style={{ width: '60px', padding: 5 }} src={iconimage ? URL.createObjectURL(iconimage) : data?.icon_path} />
                </Col>
              )}
              <Col lg="12" style={{ marginTop: 5 }}>
                <Label style={{ fontSize: ' 0.8125rem' }}>Choose Icon</Label>
                <Field name="icon" >
                  {({ input: { value, onChange, ...input }, meta }) => (
                    <div style={{
                      border: 'solid',
                      borderWidth: 'thin',
                      borderRadius: '10px',
                      padding: '8px',
                      borderColor: '#ccc',
                    }} >
                      <input
                        type="file"
                        {...input}
                        style={{ color: 'black' }}
                        onInput={fileHandlericon}
                        accept="image/png,image/jpeg"
                        onChange={(e) => onChange(e.target.files)}
                      />
                      {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                    </div>
                  )}
                </Field>
              </Col>
              {data.bg_path && (
                <Col lg="6" style={{ marginTop: 10 }}>
                  <ModalImage
                    className='image-editsize'
                    small={images ? URL.createObjectURL(images) : data?.bg_path}
                    large={images ? URL.createObjectURL(images) : data?.bg_path}
                    hideDownload={true}
                    hideZoom={true}
                  />
                </Col>
              )}
              <Col lg="12" style={{ marginTop: 5 }}>
                <Label style={{ fontSize: ' 0.8125rem' }}>Choose Background</Label>
                <Field name="background" >
                  {({ input: { value, onChange, ...input }, meta }) => (
                    <div style={{
                      border: 'solid',
                      borderWidth: 'thin',
                      borderRadius: '10px',
                      padding: '8px',
                      borderColor: '#ccc',
                    }} >
                      <input
                        type="file"
                        {...input}
                        style={{ color: 'black' }}
                        onInput={fileHandler}
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) => onChange(e.target.files)}
                      />
                      {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                    </div>
                  )}
                </Field>
              </Col>
              <Col lg="12" style={{ marginTop: 20 }}>
                <label>Places</label>
                <Card style={{ flexDirection: 'row', border: 0 }}>
                  <div style={{
                    height: '50px', alignItems: 'center', borderRadius: 12, padding: 10,
                    boxShadow: editPlaceRadio === 'GroundFloor/Upstairs' ? 'rgb(237 230 230) 0px 2px 0px 1px' : '',
                  }}>
                    <input
                      style={{ verticalAlign: 'middle' }}
                      type="radio"
                      value="GroundFloor/Upstairs"
                      name="radio1"
                      id="customRadioInline1"
                      checked={editPlaceRadio == 'GroundFloor/Upstairs'}
                      onChange={(e) => setEditPlaceRadio(e.target.value)}
                    />
                    <label style={{ fontSize: '0.73rem', margin: '0 0 0 6px', verticalAlign: 'middle' }} for="customRadioInline1">
                      GroundFloor/Upstairs
                    </label>
                  </div>
                  <div style={{
                    height: '50px', alignItems: 'center', borderRadius: 12, padding: 10,
                    boxShadow: editPlaceRadio == 'Indoor/Outdoor' ? 'rgb(237 230 230) 0px 2px 0px 1px' : '',
                  }}>
                    <input
                      style={{ verticalAlign: 'middle' }}
                      type="radio"
                      value="Indoor/Outdoor"
                      name="radio1"
                      id="customRadioInline2"
                      checked={editPlaceRadio == 'Indoor/Outdoor'}
                      onChange={(e) => setEditPlaceRadio(e.target.value)}
                    />
                    <label style={{ fontSize: '0.73rem', margin: '0 0 0 6px', verticalAlign: 'middle' }} for="customRadioInline1">
                      Indoor/Outdoor
                    </label>
                  </div>
                </Card>
              </Col>
              {editPlaceRadio === 'GroundFloor/Upstairs' ?
                <>
                  {places && places.length > 0 && (
                    places.map((item, index, child) => (
                      <>
                        <Col lg="12" style={{ marginTop: 10 }}>
                          {item.type === 'groundfloor/upstairs' ?
                            <div style={{ borderWidth: '1px', borderColor: collapse ? '#cce0ff' : '#ccc', width: '100%', padding: '10px 10px', borderRadius: 5, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                <div>
                                  <Button className={collapse === index ? "collapse_close" : "collapse_open"} onClick={() => setCollapse(collapse === index ? false : index)}></Button>
                                  <label>{item.area}</label>
                                </div>
                                <div class="checkbox-place" style={{ alignContent: 'flex-end' }}>
                                  <FormGroup check>
                                    <div className="checkbox-place" style={{ color: 'white' }}>
                                      <Input type="checkbox"
                                        name="ground_floor"
                                        value={item._id}
                                        checked={guPlacesArr.length && guPlacesArr.find(place => place.location === item._id) ? true : false}
                                      />{' '}
                                      <span style={{ fontSize: '13px', listStyle: 'none' }}></span>
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>
                              <Collapse isOpen={collapse === index ? true : false} style={{ overflowY: 'auto', maxHeight: '180px' }}>
                                {item.children && item.children.length > 0 && (
                                  item.children.map((child) => {
                                    let childArr = guPlacesArr.filter(place => place.location === item._id);
                                    return (
                                      <div>
                                        <FormGroup check>
                                          <Label check>
                                            <Input type="checkbox"
                                              style={{ marginLeft: 5 }}
                                              value={child._id}
                                              checked={childArr && childArr[0] && childArr[0].sublocation && childArr[0].sublocation.includes(child._id) ? true : false}
                                              onChange={(e) => groundfloor_upstairs(e.target.checked, child._id, item._id)}
                                            />{' '}
                                            <label style={{ marginLeft: 30 }}>{child?.area}</label>
                                          </Label>
                                        </FormGroup>
                                      </div>
                                    )
                                  })
                                )} </Collapse>
                            </div>
                            : null}
                        </Col>
                      </>
                    ))
                  )}
                </> : null
              }
              {editPlaceRadio === 'Indoor/Outdoor' ?
                <>
                  {places && places.length > 0 && (
                    places.map((item, index, child) => (
                      // let parentArr = ioPlacesArr.filter(place => place.location === item._id);
                      <>
                        {item.type === 'indoor/outdoor' ?
                          <Col lg="12" style={{ marginTop: 10 }}>
                            <div style={{ borderWidth: '1px', width: '100%', padding: '10px 10px', borderRadius: 5, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderColor: '#ccc' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                <div>
                                  <FormGroup check>
                                    <Label check>
                                      <Input type="checkbox"
                                        checked={ioPlacesArr.length && ioPlacesArr.find(place => place.location === item._id) ? true : false}
                                        value={item.type === 'indoor/outdoor' ? item.area : null}
                                        onChange={(e) => ioParentChange(e.target.checked, index, item._id)}
                                      />{' '}
                                      {item.type === 'indoor/outdoor' ? item.area : null}
                                    </Label>
                                  </FormGroup>
                                </div>
                              </div>
                              {item.children && item.children.length > 0 && (
                                item.children.map((child) => {
                                  let childArr = ioPlacesArr.filter(place => place.location === item._id);
                                  return (
                                    <div>
                                      {/* <Collapse isOpen={indcollapse === index ? true : false} style={{ overflowY: 'auto', maxHeight: '120px' }}> */}
                                      <FormGroup check>
                                        <Label check>
                                          <Input type="checkbox"
                                            value={child._id}
                                            style={{ marginLeft: 5 }}
                                            checked={childArr && childArr[0] && childArr[0].sublocation && childArr[0].sublocation.includes(child._id) ? true : false}
                                            onChange={(e) => ioChildChange(e.target.checked, child._id, item._id)}
                                          />{' '}
                                          <label style={{ marginLeft: 30 }}>{child?.area}</label>
                                        </Label>
                                      </FormGroup>
                                      {/* </Collapse> */}
                                    </div>
                                  )
                                })
                              )}
                            </div>
                          </Col> : null}
                      </>
                    ))
                  )}
                </> : null}
              <Col lg="12" style={{ marginTop: 20 }}>
                <label>pick a color</label>
                <div style={{
                  width: '0px',
                  height: '0px',
                  borderStyle: 'solid',
                  borderWidth: '0px 10px 10px',
                  borderTopColor: color_code,
                  borderBottomColor: color_code,
                  borderLeftColor: 'transparent',
                  borderRightColor: 'transparent',
                  position: 'absolute',
                  top: '-10px',
                  left: '50 %',
                  right: '30px',
                  top: '25px',
                }}></div>
                <div style={{
                  height: '60px',
                  background: color_code,
                  borderRadius: '10px 10px 10px 10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                }}><h4>{color_code}</h4>
                </div>
                <div style={{ borderWidth: '1px', borderColor: '#ccc', width: '100%', padding: '5px ', borderRadius: 5, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 20 }}>
                  <h5 style={{ color: 'rgb(134 142 150)', marginLeft: 5, alignItems: "center" }}>{color_code}</h5>
                </div>
                <div style={{ display: 'flex' }}>
                  <div class={color_code === '#f47373' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#f47373')} style={{ backgroundColor: '#f47373' }}></div>
                  <div class={color_code === '#697689' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#697689')} style={{ backgroundColor: '#697689' }} ></div>
                  <div class={color_code === '#00BCD4' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#00BCD4')} style={{ backgroundColor: '#00BCD4' }} ></div>
                  <div class={color_code === '#F78DA7' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#F78DA7')} style={{ backgroundColor: '#F78DA7' }} ></div>
                  <div class={color_code === '#FF9800' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#FF9800')} style={{ backgroundColor: '#FF9800' }} ></div>
                  <div class={color_code === '#8BC34A' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#8BC34A')} style={{ backgroundColor: '#8BC34A' }} ></div>
                  <div class={color_code === '#4CAF50' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#4CAF50')} style={{ backgroundColor: '#4CAF50' }} ></div>
                  <div class={color_code === '#CDDC39' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#CDDC39')} style={{ backgroundColor: '#CDDC39' }}></div>
                </div>
              </Col>
            </div>
            <hr className="my-4" />
            <Col md="6">
              <div style={{ paddingBottom: '30px' }}>
                <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: '#09577C', marginLeft: '40px', color: 'white', width: '100%', borderRadius: '12px', border: 0, padding: '15px 20px 15px 20px' }} >
                  {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                  UPDATE</Button>{' '}
              </div>
            </Col>
          </form>
        )}
      />
      <Modal isOpen={editsucess} size="sm">
        <ModalBody style={{ color: 'green' }}>updated successfully!</ModalBody>
      </Modal>
    </>
  );
}




const Categories = (props) => {
  const [color_code, setColor_code] = useState('#f47373');
  const [data, setData] = useState();
  const [pos, setPos] = useState(false);
  const [catcollapse, setCatcollapse] = useState(true);
  const [places, setPlaces] = useState(false);
  const [placeradio, setPlaceradio] = useState('GroundFloor/Upstairs');
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(false);
  const [open, setOpen] = useState(false);
  const [flag, setFlag] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [indcollapse, setIndcollapse] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [sucess, setSucess] = useState(false);
  const [indout, setIndout] = useState([]);
  const [parentchild, setParentchild] = useState([]);
  const [modalerroropen, setModalErroropen] = React.useState(false);
  const [duplicateopen, setDuplicateopen] = useState(false);
  const [category_place, setCategory_place] = useState(false);
  const [peropen, setPeropen] = useState(false)
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [sortdata, setSortdata] = useState(false);
  const [load, setLoad] = useState(false);
  const [flags, setFlags] = useState(false);
  const [checked, setChecked] = useState(false);
  const history = useHistory();

  const ClosemodalError = () => {
    setModalErroropen(false);
  };

  const handleClickOpen = (index) => {
    // setPos(index);
    setEditData(data[index]);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const removeData = (id, index) => {
    dataProvider.delete('category', { id: id });
    let userArr = data;
    userArr.splice(index, 1);
    setData(userArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('category', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {}, token: token })
      .then(({ data }) => {
        setSortdata(true)
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setData(data);
      })
    dataProvider.getList('places/list', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {}, token: token })
      .then(({ data }) => {
        setPlaces(data);
        setPlaces(data[0].data ? data[0].data : null);
      })
      .catch(error => { });
  }, [props, reload]);

  const onSubmit = (values) => {
    setLoading(true)
    dataProvider.createCategories('category', { ...values, places: placeradio, color_code: color_code, groundfloor_upstairs: parentchild, indoor_outdoor: indout })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true);
        setTimeout(() => Pushcreate(), 2000);
        history.push("/categories")
      })

      .catch(error => {
        setLoading(false)
        if (error.response.status === 500) {
          setModalErroropen(true);
        }
        if (error?.response?.status === 400) {
          setDuplicateopen(true)
        }
      });
  };
  const onChangeRadio = (e) => {
    if (e === 'Indoor/Outdoor') {
      setParentchild([]);
    } else {
      setIndout([]);
    }
    setPlaceradio(e);
  }

  // const ioParentChange = (e, index, pid) => {
  //   let Exist = indout.length && indout.find(item => item.location === pid);
  //   if (!Exist) {
  //     setIndout([{ location: pid, sublocation: [] }])
  //   }
  //   if (e.target.checked) {
  //     setIndcollapse(index)
  //   } else {
  //     setIndcollapse(false);
  //   }
  // }

  const ioParentChange = (check, index, pid) => {
    if (check) {
      setIndout(prevState => [...prevState, { location: pid, sublocation: [] }]);
    }
    else {
      let arrAfterRemove = indout.filter(item => item.location !== pid)
      setIndout(arrAfterRemove);
    }
    if (check) {
      setIndcollapse(index);
    } else {
      setIndcollapse(false);
    }
  }
  const ioChildChange = (check, child, pid) => {
    if (check) {
      let Exist = indout.length && indout.find(item => item.location === pid);
      if (Exist) {
        let NewArr = indout.length && indout.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        childrenExist.push(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setIndout(NewArr);
      }
      else {
        let childrenArr = [];
        childrenArr.push(child);
        childrenArr = [...new Set(childrenArr)];
        let info = { location: pid, sublocation: childrenArr };
        setIndout(prevState => [...prevState, info]);
        setFlags(!flags)
      }
    } else {
      let Exist = indout.length && indout.find(item => item.location === pid);
      if (Exist) {
        let NewArr = indout.length && indout.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        var i = childrenExist.indexOf(child);
        if (i !== -1) {
          childrenExist.splice(i, 1);
        }
        // childrenExist.pop(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setIndout(NewArr);
      }
    }
  }
  const groundfloor_upstairs = (check, child, pid) => {
    if (check) {
      let Exist = parentchild.length && parentchild.find(item => item.location === pid);
      if (Exist) {
        let NewArr = parentchild.length && parentchild.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        childrenExist.push(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setParentchild(NewArr);
      }
      else {
        let childrenArr = [];
        childrenArr.push(child);
        childrenArr = [...new Set(childrenArr)];
        let info = { location: pid, sublocation: childrenArr };
        setParentchild(prevState => [...prevState, info]);
      }
    } else {
      let Exist = parentchild.length && parentchild.find(item => item.location === pid);
      if (Exist) {
        let NewArr = parentchild.length && parentchild.filter(item => item.location !== pid);
        let childrenExist = Exist.sublocation;
        childrenExist.pop(child);
        childrenExist = [...new Set(childrenExist)];
        let info1 = { location: pid, sublocation: childrenExist };
        NewArr.push(info1);
        setParentchild(NewArr);
      }
    }
  }
  const duplicatemodalclose = () => {
    setDuplicateopen(false)
  }
  const Pushcreate = () => {
    setSucess(false)
    window.location.reload()
  }
  const collapseid = (id, index) => {
    setLoad(true)
    setCatcollapse(catcollapse === index ? false : index)
    dataProvider.getCategory_Place({ id }, { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setCategory_place(data.places);
        setLoad(false)
      })
  }
  let token = localStorage.getItem('token');
  let per = localStorage.getItem('permission');
  // const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;

  const perModal = () => {
    setPeropen(true)
  }
  const permodalClose = () => {
    setPeropen(false)
  }
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const handleDragEnd = (e) => {
    setSortdata(false)
    if (!e.destination) return;
    let tempData = Array.from(data);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setData(tempData);
    // let eId = source_data._id;
    // let sourceorder =e?.source?.index;
    dataProvider.sortCategories('category/order', tempData)
      .then(({ data }) => {
        setSortdata(true)
      })
      .catch(error => { });
  };
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white' }}>CATEGORIES</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid >
        <Row className="mt-5" >
          <Col className xl="8" style={{ paddingLeft: 0 }}  >
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}><h3>CATEGORIES</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Table className="align-items-center table-flush" style={{ padding: 0, margin: 0 }}>
                  <thead className="thead-light"  >
                    <tr>
                      <th scope="col" ></th>
                      <th scope="col" style={{ width: 100 }}>CATEGORY NAME</th>
                      <th scope="col" >ICON</th>
                      <th scope="col" >BG IMAGE</th>
                      <th scope="col" >COLOR</th>
                      <th scope="col" ></th>
                      <th scope="col" >ACTION</th>
                      <th scope="col" style={{ paddingRight: 0 }} >SORT</th>
                    </tr>
                  </thead>
                  <Droppable droppableId="droppable-1">
                    {(provider) => (
                      <tbody
                        className="text-capitalize"
                        ref={provider.innerRef}
                        {...provider.droppableProps}
                      >
                        {data && data.length > 0 && (
                          data.map((item, index) => (
                            <Draggable
                              key={item.category}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provider) => (
                                <tr {...provider.draggableProps} ref={provider.innerRef} >
                                  <td style={{ paddingRight: 0 }}>
                                    <Button className={catcollapse === index ? "button_collapse_close" : "button_collapse_open"} onClick={() => collapseid(item._id, index)}></Button>
                                  </td>
                                  <td style={{ color: '#12ACF6', width: 100, paddingRight: 0 }}>
                                    <div>{item.category}</div>
                                    <Collapse isOpen={catcollapse === index ? true : false}>
                                      <div style={{ color: 'black', marginTop: 10, fontSize: '10px' }}>{item.category_arabic}</div>
                                      <div style={{ color: 'black', marginBottom: 10, fontSize: '10px' }}>PLACES</div>
                                      {load ? <Spinner size="sm" /> : category_place && category_place.length > 0 && (
                                        category_place.map((item, index) => (
                                          <>
                                            {item.children && item.children.length > 0 && (
                                              item.children.map((child) => (
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                  <label style={{ color: '#677888', fontSize: '0.6rem', fontWeight: 600 }}>{child.title} ({item.title})</label>
                                                </div>
                                              ))
                                            )}
                                          </>
                                        ))
                                      )}
                                    </Collapse>
                                  </td>
                                  <td>
                                    <div style={{ backgroundColor: 'rgb(103 120 136)', borderRadius: 5, textAlign: 'center' }}>
                                      <img
                                        style={{ textAlign: 'center', padding: 7, width: 40, height: 40 }}
                                        src={item.icon_path}
                                        className="img-fluid"
                                        alt="..."
                                      />
                                    </div>
                                  </td>
                                  <td style={{ width: '0.1rem', paddingLeft: 10 }}>
                                    <ModalImage
                                      className='image-bgsize'
                                      small={item.bg_path}
                                      large={item.bg_path}
                                      hideDownload={true}
                                      hideZoom={true}
                                    />
                                  </td>
                                  <td><div style={{ backgroundColor: item.color_code ? item.color_code : 'yellow', width: '40px', height: '40px', borderWidth: 5, borderColor: '#222424', borderRadius: 5, border: '1px solid black' }}></div> </td>
                                  <td style={{ fontSize: '10px', color: '#acacac' }}>{item.color_code}</td>
                                  <td class="w-25 p-3" style={{ flexDirection: 'row', display: 'flex' }}>
                                    {per.includes('category_edit') ?
                                      <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}
                                        onClick={() => handleClickOpen(index)}>
                                        <IcomoonReact iconSet={iconSet} color="#ccc" size={14} icon="edit" />
                                      </Button> :
                                      <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}>
                                        <IcomoonReact iconSet={iconSet} color="#ccc" size={14} icon="edit" />
                                      </Button>}
                                    {per.includes('category_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: item.id, index: index })}><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /> </Button> :
                                      <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }}><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="delete" /> </Button>}
                                  </td>
                                  {sortdata ?
                                    <td {...provider.dragHandleProps} style={{ color: '#12ACF6', fontSize: '1rem', paddingRight: 0 }}>...</td>
                                    : <td style={{ color: '#12ACF6', fontSize: '1rem', paddingRight: 0 }}></td>}
                                </tr>
                              )}
                            </Draggable>
                          ))
                        )}
                        {provider.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </Table>
              </DragDropContext>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <div className="modal-header"></div>
                <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </Col>
          <Col xs="4" style={{ maxWidth: '360px', padding: 0 }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0" style={{ marginLeft: 10, fontWeight: 'bold', color: '#62635e' }}>ADD CATEGORY</h3>
                  </div>
                </Row>
              </CardHeader>
              <Form
                onSubmit={onSubmit}
                validate={values => {
                  const errors = {};
                  if (!values.category) {
                    errors.category = "Required";
                  }
                  if (!values.category_arabic) {
                    errors.category_arabic = "Required";
                  }
                  if (!values.icon) {
                    errors.icon = "Required";
                  }
                  if (!values.background) {
                    errors.background = "Required";
                  }
                  return errors;
                }}
                render={({ handleSubmit, reset, form }) => (
                  <form onSubmit={handleSubmit} style={{ padding: '10px', borderRadius: 10 }}>
                    <div className="pl-lg-4">
                      <Row style={{ padding: 0 }}>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }}>
                            <Label style={{ fontSize: ' 0.9rem', color: '#62635e' }} for="name">Category Name</Label>
                            <Field name="category" >
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    placeholder="Category Name"
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12" >
                          <FormGroup style={{ marginBottom: 10 }} >
                            <Label style={{ fontSize: ' 0.9rem', color: '#62635e' }} for="category">Category</Label>
                            <Field name="parent">
                              {({ input, meta, value }) => (
                                <div>
                                  <Input type="select"  {...input} name="parent" id="category" style={{ color: 'black', borderRadius: 10 }}>
                                    <option value="" style={{ color: '#ccc' }} >Choose parent Category</option>
                                    {data && data.map((item, index) => {
                                      if (!item.parent) {
                                        return (<option value={item.id}>{item.category}</option>)
                                      }
                                      else { return null; }
                                    })}
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }}>
                            <Label style={{ fontSize: ' 0.9rem', color: '#62635e' }} for="name">Arabic Name</Label>
                            <Field name="category_arabic">
                              {({ input, meta }) => (
                                <div>
                                  <Input
                                    dir="rtl"
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    placeholder="Arabic Name"
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <Label style={{ fontSize: ' 0.9rem', color: '#62635e' }}>Choose Icon</Label>
                          <Field name="icon">
                            {({ input: { value, onChange, ...input }, meta }) => (
                              <div style={{
                                border: 'solid',
                                borderWidth: 'thin',
                                borderRadius: '10px',
                                padding: '8px', borderColor: '#ccc'
                              }} >
                                <Input
                                  {...input}
                                  //name="icon"
                                  accept="image/png,image/jpeg"
                                  style={{ color: 'black' }}
                                  type="file"
                                  onChange={(e) => onChange(e.target.files)}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col lg="12" style={{ marginTop: 20 }}>
                          <Label style={{ fontSize: ' 0.9rem', color: '#62635e' }}>Choose Background</Label>
                          <Field name="background">
                            {({ input: { value, onChange, ...input }, meta }) => (
                              <div style={{
                                border: 'solid',
                                borderWidth: 'thin',
                                borderRadius: '10px',
                                padding: '8px', borderColor: '#ccc'
                              }}>
                                <Input
                                  accept="image/png,image/jpeg"
                                  style={{ color: 'black' }}
                                  type="file"
                                  onChange={(e) => onChange(e.target.files)}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </Col>
                        <Col lg="12" style={{ marginTop: 20 }}>
                          <label>Places</label>
                          <Card style={{ flexDirection: 'row', border: 0 }}>
                            <div style={{
                              height: '50px', alignItems: 'center', borderRadius: 12, padding: 10,
                              boxShadow: placeradio === 'GroundFloor/Upstairs' ? 'rgb(237 230 230) 0px 2px 0px 1px' : '',
                            }}>
                              <input
                                style={{ verticalAlign: 'middle' }}
                                type="radio"
                                value="GroundFloor/Upstairs"
                                name="radio1"
                                id="customRadioInline1"
                                checked={placeradio == 'GroundFloor/Upstairs'}
                                onChange={(e) => onChangeRadio(e.target.value)}
                              />
                              <label style={{ fontSize: '0.73rem', margin: '0 0 0 6px', verticalAlign: 'middle' }} for="customRadioInline1">
                                GroundFloor/Upstairs
                              </label>
                            </div>
                            <div style={{
                              height: '50px', alignItems: 'center', borderRadius: 12, padding: 10,
                              boxShadow: placeradio !== 'GroundFloor/Upstairs' ? 'rgb(237 230 230) 0px 2px 0px 1px' : '',
                            }}>
                              <input
                                style={{ verticalAlign: 'middle' }}
                                type="radio"
                                value="Indoor/Outdoor"
                                name="radio1"
                                id="customRadioInline2"
                                // checked={placeradio == 'Indoor/Outdoor'}
                                onChange={(e) => onChangeRadio(e.target.value)}
                              />
                              <label style={{ fontSize: '0.73rem', margin: '0 0 0 6px', verticalAlign: 'middle' }} for="customRadioInline1">
                                Indoor/Outdoor
                              </label>
                            </div>
                          </Card>
                        </Col>
                        {placeradio === 'GroundFloor/Upstairs' ?
                          <>
                            {places && places.length > 0 && (
                              places.map((item, index, child) => (
                                <>
                                  <Col lg="12" style={{ marginTop: 10 }}>
                                    {item.type === 'groundfloor/upstairs' ?
                                      <div style={{ borderWidth: '1px', borderColor: collapse ? '#cce0ff' : '#ccc', width: '100%', padding: '10px 10px', borderRadius: 5, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                          <div>
                                            <Button className={collapse === index ? "collapse_close" : "collapse_open"} onClick={() => setCollapse(collapse === index ? false : index)}></Button>
                                            <label>{item.type === 'groundfloor/upstairs' ? item.area : null}</label>
                                          </div>
                                          <div class="checkbox-place" style={{ alignContent: 'flex-end' }}>
                                            <FormGroup check>
                                              <div className="checkbox-place" style={{ color: 'white' }}>
                                                <Input type="checkbox"
                                                  name="ground_floor"
                                                  value={item._id}
                                                  checked={true}
                                                // onChange={(e) => { checked_circle(e.target.checked, item._id) }}
                                                />{' '}
                                                <span style={{ fontSize: '13px', listStyle: 'none' }}></span>
                                              </div>
                                            </FormGroup>
                                          </div>
                                        </div>
                                        <Collapse isOpen={collapse === index ? true : false} style={{ overflowY: 'auto', maxHeight: '200px' }}>
                                          {item.children && item.children.length > 0 && (
                                            item.children.map((child) => (
                                              <div>
                                                <FormGroup check>
                                                  <Label check>
                                                    <Input type="checkbox"
                                                      value={child._id}
                                                      onChange={(e) => groundfloor_upstairs(e.target.checked, child._id, item._id)}
                                                    />{' '}
                                                    {child?.area}
                                                  </Label>
                                                </FormGroup>
                                              </div>
                                            ))
                                          )} </Collapse>
                                      </div>
                                      : null}
                                  </Col>
                                </>
                              ))
                            )}
                          </> : null
                        }
                        {placeradio === 'Indoor/Outdoor' ?
                          <>
                            {places && places.length > 0 && (
                              places.map((item, index, child) => (
                                <>
                                  {item.type === 'indoor/outdoor' ?
                                    <Col lg="12" style={{ marginTop: 10 }}>
                                      <div style={{ borderWidth: '1px', width: '100%', padding: '10px 10px', borderRadius: 5, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderColor: '#ccc' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                          <div>
                                            <FormGroup check>
                                              <Label check>
                                                <Input type="checkbox"
                                                  // checked={checked}
                                                  value={item.type === 'indoor/outdoor' ? item.area : null}
                                                  onChange={(e) => ioParentChange(e.target.checked, index, item._id)}
                                                />{' '}
                                                {item.type === 'indoor/outdoor' ? item.area : null}
                                              </Label>
                                            </FormGroup>
                                          </div>
                                        </div>
                                        {item.children && item.children.length > 0 && (
                                          item.children.map((child) => (
                                            <div>
                                              <Collapse isOpen={indcollapse === index ? true : false} style={{ overflowY: 'auto', maxHeight: '120px' }}>
                                                <FormGroup check>
                                                  <Label check>
                                                    <Input type="checkbox"
                                                      style={{ marginLeft: 5 }}
                                                      value={child._id}
                                                      onChange={(e) => ioChildChange(e.target.checked, child._id, item._id)}
                                                    />{' '}
                                                    <label style={{ marginLeft: 30 }}>{child?.area}</label>
                                                  </Label>
                                                </FormGroup>
                                              </Collapse>
                                            </div>
                                          ))
                                        )}
                                      </div>
                                    </Col> : null}
                                </>
                              ))
                            )}
                          </> : null}
                        <Col lg="12" style={{ marginTop: 20 }}>
                          <label>pick a color</label>
                          <div class="color_end" style={{ borderTopColor: color_code, borderBottomColor: color_code }}></div>
                          <div class="color_box" style={{ background: color_code }}><h5>{color_code}</h5>
                          </div>
                          <div style={{ borderWidth: '1px', borderColor: '#ccc', width: '100%', padding: '5px ', borderRadius: 5, borderStyle: 'solid', marginTop: 20 }}>
                            <h5 style={{ color: 'rgb(134 142 150)', marginLeft: 5, alignItems: "center" }}>{color_code}</h5>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <div class={color_code === '#f47373' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#f47373')} style={{ backgroundColor: '#f47373' }}></div>
                            <div class={color_code === '#697689' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#697689')} style={{ backgroundColor: '#697689' }} ></div>
                            <div class={color_code === '#00BCD4' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#00BCD4')} style={{ backgroundColor: '#00BCD4' }} ></div>
                            <div class={color_code === '#F78DA7' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#F78DA7')} style={{ backgroundColor: '#F78DA7' }} ></div>
                            <div class={color_code === '#FF9800' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#FF9800')} style={{ backgroundColor: '#FF9800' }} ></div>
                            <div class={color_code === '#8BC34A' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#8BC34A')} style={{ backgroundColor: '#8BC34A' }} ></div>
                            <div class={color_code === '#4CAF50' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#4CAF50')} style={{ backgroundColor: '#4CAF50' }} ></div>
                            <div class={color_code === '#CDDC39' ? "color_circle active" : "color_circle"} onClick={() => setColor_code('#CDDC39')} style={{ backgroundColor: '#CDDC39' }}></div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    {per.includes('category_edit') ?
                      <Col lg="12" style={{ marginTop: 20 }}>
                        <div style={{ paddingRight: 0, marginLeft: 10 }}>
                          <Button disabled={loading} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', borderRadius: 10, padding: 18, border: 0, marginBottom: 20 }}>
                            {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                            ADD</Button>{' '}
                        </div>
                      </Col> :
                      <Col lg="12">
                        <div style={{ paddingRight: '0px', marginLeft: 10 }}>
                          <Button onClick={() => perModal()} disabled={loading} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', borderRadius: 10, padding: 18, border: 0, marginBottom: 20 }}>
                            ADD</Button>{' '}
                        </div>
                      </Col>}
                  </form>
                )}
              />
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={modalerroropen} size="sm">
        <ModalBody style={{ color: 'red' }}>Please fill all the mandatory fields...!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20, marginRight: 20 }}>
          <Button onClick={ClosemodalError} style={{ backgroundColor: '#ff473a', color: 'white' }} type="button">
            OK
          </Button>
        </div>
      </Modal>
      <Modal isOpen={duplicateopen} size="sm">
        <ModalBody style={{ color: 'red' }}>Category already exists...!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
          <Button onClick={duplicatemodalclose} style={{ backgroundColor: '#eb4b4b', color: 'white', border: 0 }} type="button">
            Ok
          </Button>
        </div>
      </Modal>
      <Modal
        className="modal-dialog-centered"
        isOpen={open}
      >
        <div style={{ backgroundColor: '#09577C', padding: 20 }} >
          <h4 style={{ textAlign: "center", marginTop: '20px', color: 'white' }} >
            CATEGORY EDIT
          </h4>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            <div style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
              <IcomoonReact iconSet={iconSet} onClick={handleClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
            </div>
          </button>
        </div>
        <div>
          {editData && (<EditCategory data={editData} category={data} places={places} open={open} setOpen={setOpen} />)}
        </div>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => permodalClose()} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
    </>
  );
};

export default Categories;

